(function($) {
	"use strict";

	// **************************************
	//      FORM SUBMIT
	// **************************************

	/**
	 * Returns the value of the field with the given name
	 */
	var getFormValue = function(name) {
		var htmlElement = $('#cf-' + name);
		if (!htmlElement) {
			return undefined;
		}

		var value = htmlElement.val();

		// Check if the value on the input-field got changed
		if (htmlElement.attr('placeholder') === value) {
			// The element still has the value of the placeholder
			return undefined;
		}

		return value;
	};


	/**
	 * Checks if the given email address is correct
	 * From: http://stackoverflow.com/questions/2855865/jquery-regex-validation-of-e-mail-address
	 * @param emailAddress The email address to check
	 * @returns {boolean}
	 */
	var isValidEmailAddress = function(emailAddress) {
		var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
		return pattern.test(emailAddress);
	};



	/**
	 * Checks if all the needed values got filled and are valid and then submits
	 * the form to the server
	 */
	var submitForm = function(formName, parentFormClass, dataFields, sendButton, successCallback) {
		// Deactivate send mutton
		sendButton.addClass('disabled');

		// Change button text
		var originalButtonText = sendButton.text();
		sendButton.text('Sending...');

		var errorMessages = [];
		var sendData = {};

		Object.keys(dataFields).forEach(function(fieldName) {
			var fieldData = dataFields[fieldName];

			// Hide all the error messages
			$(parentFormClass + ' #cf-error-'+fieldName).addClass('hidden');
			$(parentFormClass + ' #cf-'+fieldName).css({'border-color': ''});

			var fieldValue = getFormValue(fieldName);
			sendData[fieldName] = fieldValue;

			// Check if the values are valid
			if (fieldData.optional === true) {
				// Is optional value so no need to check
				return;
			}

			if (fieldValue === undefined) {
				// Value is empty
				errorMessages.push({field: fieldName, message: fieldData.name + ' is empty.'});
			} else if(fieldData.hasOwnProperty('checkFunction') && !fieldData.checkFunction(fieldValue)) {
				// Value is not valid according to check function
				errorMessages.push({field: fieldName, message: fieldData.name + ' is not valid.'});
			}
		});

		// If there is something wrong with the data inform the user and
		// do not send the email
		if (errorMessages.length !== 0) {
			// There are problems so display error message and stop
			errorMessages.forEach(function(errorMessage) {
				// errorMessage
				var errorField = $(parentFormClass + ' #cf-error-'+errorMessage.field);
				errorField.removeClass('hidden');
				errorField.html(errorMessage.message);
				$(parentFormClass + ' #cf-'+errorMessage.field).css({'border-color': 'red'});
			});

			// Activate send button again and revert text
			sendButton.removeClass('disabled');
			sendButton.text(originalButtonText);
			return;
		}

		// Make the text fields read only
		Object.keys(dataFields).forEach(function(fieldName) {
			$(parentFormClass + ' #cf-'+fieldName).prop("readonly", true);
		});

		// Send data to server to send email
		sendData.formName = formName;
		$.ajax({
			type: "POST",
			data: sendData,
			dataType: "json",
			url: "https://dashboard.applanga.com/v1/websites/submit-form/",
			success: function(data, status, jqXHR){
				sendButton.removeClass('disabled');
				sendButton.text(originalButtonText);
				$(parentFormClass + ' .form-fields').addClass('hidden');
				$(parentFormClass + ' #form-send-success').removeClass('hidden');
				// Remove the text fields read only
				Object.keys(dataFields).forEach(function(fieldName) {
					$(parentFormClass + ' #cf-'+fieldName).prop("readonly", false);
				});
				if (successCallback) successCallback();
			},
			error: function(jqXHR, status, err) {

				// Remove the text fields read only
				Object.keys(dataFields).forEach(function(fieldName) {
					$(parentFormClass + ' #cf-'+fieldName).prop("readonly", false);
				});

				sendButton.removeClass('disabled');
				sendButton.text(originalButtonText);

				alert('There was a problem please try again later');
			}
		});
	};


	// **************************************
	//      CONTACT FORM MODAL
	// **************************************

	// Now that jquery got loaded we can display the from again normally because
	// now it did hide it by itself. If we would not hide it initially our self
	// it would flicker because it would be displayed very short in the beginning.
	window.applangaHelpers.executeWhenExist('.contact-form', 25, 250, function() {
		$('.contact-form').removeClass('hidden');

		var contactDialog = $("#contact-form").dialog({
			dialogClass: "contact-form-dialog",
			autoOpen: false,
			resizable: false,
			width: 400,
			modal: true,
			open: function() {
				var sendButton = $('#send-contact-form-button');

				// Define the fields we want to submit the data of
				var dataFields = {
					name: {
						name: 'Name',
						optional: false
					},
					email: {
						name: 'E-Mail',
						optional: false,
						checkFunction: isValidEmailAddress
					},
					phone: {
						name: 'Phone',
						optional: true
					},
					message: {
						name: 'Message',
						optional: false
					}
				};

				// Call submitForm function whenever the submit-button gets pressed
				sendButton.click(function() {
					var parentFormClass = '.contact-form-dialog';
					submitForm('contactForm', parentFormClass, dataFields, sendButton, function() {
						// Did send the data. Add code for appearing close button.
						var closeButton = $('#close-contact-form-button');
						closeButton.click(function() {
							$(parentFormClass + ' .form-fields').removeClass('hidden');
							$(parentFormClass + ' #form-send-success').addClass('hidden');
							contactDialog.dialog( "close" );
						});
					});
				});
			}
		});

		$(".open-contact-form").button().on( "click", function() {
			contactDialog.dialog( "open" );
		});
	});


	// **************************************
	//      NEWSLETTER FORM MODAL
	// **************************************

	// Now that jquery got loaded we can display the from again normally because
	// now it did hide it by itself. If we would not hide it initially our self
	// it would flicker because it would be displayed very short in the beginning.
	window.applangaHelpers.executeWhenExist('.newsletter-form', 25, 250, function() {
		$('.newsletter-form').removeClass('hidden');

		var newsletterDialog = $('#newsletter-form').dialog({
			dialogClass: "newsletter-form-dialog",
			autoOpen: false,
			resizable: false,
			width: 400,
			modal: true
		});

		$('.open-newsletter-form').button().on( 'click', function() {
			newsletterDialog.dialog( 'open' );
		});
	});

	// Makes sure that the submit button is only clickable when checkbox is checked
	$("#newsletter-marketing-permission").change(
		function (e) {
			if ($(this).is(":checked")) {
				$('#mc-embedded-subscribe').prop("disabled", false);
			} else {
				$('#mc-embedded-subscribe').prop("disabled", true);
			}
		}
	);

	// **************************************
	//      DEMO PAGE
	// **************************************


	// No need to use "executeWhenExist" because will directly exists on load
	// because is only on static page
	var sendButton = $('#send-request-button');

	if (sendButton.length) {
		// Define the fields we want to submit the data of
		var dataFields = {
			name: {
				name: 'Name',
				optional: false
			},
			email: {
				name: 'E-Mail',
				optional: false,
				checkFunction: isValidEmailAddress
			},
			time: {
				name: 'Time',
				optional: false
			},
			timezone: {
				name: 'Timezone',
				optional: false
			},
			message: {
				name: 'Message',
				optional: true
			}
		};

		// Call submitForm function whenever the submit-button gets pressed
		sendButton.click(function() {
			submitForm('demoRequest', '.vertical-schedule-form', dataFields, sendButton);
		});
	}


})(jQuery);
